export default "__VITE_ASSET__DYgkMHN7__"